import { v4 } from '@lukeed/uuid';
import { cloneData1D } from '../utilities/cloneData1D';
import { cloneData2D } from '../utilities/cloneData2D';
import { Filters } from './Filters';
import { updateIntegrals } from './data1d/utils/updateIntegrals';
import { updatePeaks } from './data1d/utils/updatePeaks';
import { updateRanges } from './data1d/utils/updateRanges';
import { updateZones } from './data2d/utils/updateZones';
function resetDataToOrigin(datum) {
    datum.data =
        datum.info.dimension === 1
            ? cloneData1D(datum.originalData)
            : cloneData2D(datum.originalData);
    const { originalInfo } = datum;
    if (originalInfo) {
        datum.info = { ...originalInfo };
    }
}
// update the the part of the data that affected by applying the filters
function updateData(datum) {
    if (datum.info.dimension === 1) {
        updatePeaks(datum);
        updateRanges(datum);
        updateIntegrals(datum);
    }
    else if (datum.info.dimension === 2) {
        updateZones(datum);
    }
}
/***
 * @param {object} Filters [{name:'',options:{}},{...}]
 */
export function applyFilter(datum, filters = [], options = {}) {
    const { forceReapply = false, filterIndex } = options;
    let isReduced = false;
    for (let filter of filters) {
        const filterOption = {
            name: filter.name,
            label: Filters[filter.name].name,
            value: filter.value,
        };
        const previousFilter = lookupForFilter(datum, filter.name);
        const isDeleteAllow = 'isDeleteAllow' in filter ? filter.isDeleteAllow : true;
        if (previousFilter) {
            const reduceResult = Filters[filter.name].reduce(previousFilter.value, filterOption.value);
            if (reduceResult.once) {
                if (!isReduced) {
                    isReduced = true;
                }
                if (reduceResult.reduce != null && reduceResult.reduce !== undefined) {
                    replaceFilter(datum, previousFilter.id, reduceResult.reduce);
                }
            }
            else {
                addFilter(datum, filterOption, { isDeleteAllow, filterIndex });
            }
        }
        else {
            addFilter(datum, filterOption, { isDeleteAllow, filterIndex });
        }
    }
    if (forceReapply) {
        reapplyFilters(datum);
    }
    else if (isReduced) {
        if (filters.length === 1 && isLastFilter(datum, filters[0].name)) {
            Filters[filters[0].name].apply(datum, filters[0].value);
        }
        else {
            reapplyFilters(datum);
        }
    }
    else {
        for (let filter of filters) {
            Filters[filter.name].apply(datum, filter.value);
        }
    }
    updateData(datum);
}
function isLastFilter(datum, id) {
    const index = datum.filters.findIndex((f) => f.name === id);
    if (datum.filters.length === index + 1) {
        return true;
    }
    return false;
}
export function lookupForFilter(datum, filterName) {
    return datum.filters.find((f) => f.name === filterName);
}
export function reapplyFilters(datum, filters) {
    const _filters = filters || datum.filters;
    enableFilter(datum, null, null, _filters);
}
// id filter id
export function enableFilter(datum, id, checked, filters) {
    datum.filters = datum.filters.slice(0);
    if (id) {
        datum.filters = datum.filters.map((filter) => {
            return { ...filter, flag: filter.id === id ? checked : filter.flag };
        });
    }
    resetDataToOrigin(datum);
    const _filters = filters || datum.filters;
    for (let filterIndex = 0; filterIndex < _filters.length; filterIndex++) {
        const filter = datum.filters[filterIndex];
        datum.filters[filterIndex] = {
            ...datum.filters[filterIndex],
        };
        if (filter.flag) {
            try {
                Filters[filter.name].apply(datum, filter.value);
            }
            catch (error) {
                datum.filters[filterIndex] = {
                    ...datum.filters[filterIndex],
                    error: error.message,
                };
            }
        }
    }
}
export function deleteFilter(datum, id) {
    // delete the specified filter otherwise delete all filters where isDeleteAllow is true
    datum.filters = datum.filters
        .slice(0)
        .filter((filter) => (id ? filter.id !== id : !filter.isDeleteAllow));
    resetDataToOrigin(datum);
    for (let i = 0; i < datum.filters.length; i++) {
        datum.filters[i] = {
            ...datum.filters[i],
        };
        if (datum.filters[i].flag) {
            const { name, value } = datum.filters[i];
            try {
                Filters[name].apply(datum, value);
            }
            catch (error) {
                datum.filters[i] = {
                    ...datum.filters[i],
                    error: error.message,
                };
            }
        }
    }
    updateData(datum);
}
export function addFilter(datum, filterOptions, options = {}) {
    const { filterIndex, isDeleteAllow = true } = options;
    const id = v4();
    const filter = {
        ...filterOptions,
        id,
        flag: true,
        isDeleteAllow,
    };
    if (typeof filterIndex === 'number' && filterIndex !== -1) {
        datum.filters = [
            ...datum.filters.slice(0, filterIndex + 1),
            filter,
            ...datum.filters.slice(filterIndex + 1),
        ];
    }
    else {
        datum.filters.push(filter);
    }
}
function replaceFilter(datum, filterID, value) {
    // datum.filters = datum.filters.slice(0);
    const index = datum.filters.findIndex((f) => f.id === filterID);
    datum.filters[index] = {
        ...datum.filters[index],
        value,
    };
}
//# sourceMappingURL=FiltersManager.js.map